<template>
  <div class="loading">
    <div class="loading__spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen'
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: get-color('dark', 'opacity');
  z-index: 1;
  display: grid;
  justify-content: center;
  align-content:center;

  &__spinner {
    border: 10px solid transparent;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border-left-color: get-color('primary', 'darker');
    border-right-color: get-color('primary', 'darker');
    animation: spin 1.1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
